module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "container",
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "segment box"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Penalty Type")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PenaltySelected),
      expression: "PenaltySelected"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.PenaltySelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.PenaltyOptions), function(option) {
    return _c('option', {
      key: option.value,
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 0)])]), _vm._v(" "), _c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("League Penalty Differentials")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Last Crawler Run - 18-01-2020")]), _vm._v(" "), _c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/eihl/penalties/team-diff",
      "postData": [{
        pen_type: _vm.PenaltySelected,
      }],
      "selectedData": [{
          title: 'Team',
          prop: 'name'
        },
        {
          title: 'Taken',
          prop: 'pims_plus'
        },
        {
          title: 'Drawn',
          prop: 'pims_minus'
        },
        {
          title: '+/-',
          prop: 'pims_diff'
        }
      ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f27656c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/stats/season-stats/eihl_penalties.vue
// module id = 643
// module chunks = 30